import type { BadgeProps } from 'shared/ui/Badge';

import type { OnboardingStatus } from '../../model';

export const statusMap: Record<OnboardingStatus, { color: BadgeProps['color']; text: string }> = {
  done: { color: 'deepGreen', text: 'Done' },
  pending: { color: 'orange', text: 'Pending' },
  inProgress: { color: 'mint', text: 'In progress' },
};
